__turbopack_context__.v({
  "closeBtn": "ShareModal-module__x8RmyG__closeBtn",
  "copiedMessage": "ShareModal-module__x8RmyG__copiedMessage",
  "copyButton": "ShareModal-module__x8RmyG__copyButton",
  "fadeInOut": "ShareModal-module__x8RmyG__fadeInOut",
  "header": "ShareModal-module__x8RmyG__header",
  "linkContainer": "ShareModal-module__x8RmyG__linkContainer",
  "linkInput": "ShareModal-module__x8RmyG__linkInput",
  "modal": "ShareModal-module__x8RmyG__modal",
  "modalBody": "ShareModal-module__x8RmyG__modalBody",
  "modalDesktop": "ShareModal-module__x8RmyG__modalDesktop",
  "modalMobile": "ShareModal-module__x8RmyG__modalMobile",
  "overlay": "ShareModal-module__x8RmyG__overlay",
  "root": "ShareModal-module__x8RmyG__root",
  "rootDesktop": "ShareModal-module__x8RmyG__rootDesktop",
  "rootMobile": "ShareModal-module__x8RmyG__rootMobile",
  "shareIcon": "ShareModal-module__x8RmyG__shareIcon",
  "shareIcons": "ShareModal-module__x8RmyG__shareIcons",
  "shareOptionsSection": "ShareModal-module__x8RmyG__shareOptionsSection",
  "shareOptionsTitle": "ShareModal-module__x8RmyG__shareOptionsTitle",
  "sharingLabel": "ShareModal-module__x8RmyG__sharingLabel",
  "sharingLinkSection": "ShareModal-module__x8RmyG__sharingLinkSection",
  "sheetUp": "ShareModal-module__x8RmyG__sheetUp",
  "title": "ShareModal-module__x8RmyG__title",
});
